import { render, staticRenderFns } from "./icon-calendar.vue?vue&type=template&id=7d42d378&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d42d378')) {
      api.createRecord('7d42d378', component.options)
    } else {
      api.reload('7d42d378', component.options)
    }
    module.hot.accept("./icon-calendar.vue?vue&type=template&id=7d42d378&", function () {
      api.rerender('7d42d378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/icons/icon-calendar.vue"
export default component.exports